import { useState } from 'react';
import { Radio } from 'antd';
import ContractInsuranceType, { allCases, exist } from '@/components/organisms/contract/ContractInsuranceType';

type ContractInsuranceTypeSelectorProps = {
  onChange?: (type: ContractInsuranceType) => void;
  defaultSelected?: ContractInsuranceType;
};

const ContractInsuranceTypeSelector = ({ onChange, defaultSelected }: ContractInsuranceTypeSelectorProps) => {
  const [selected, setSelected] = useState();

  return (
    <Radio.Group
      defaultValue={defaultSelected}
      value={selected}
      onChange={({ target }) => {
        setSelected(target.value);
        if (onChange) {
          onChange(target.value);
        }
      }}
      options={allCases.map((type) => ({
        label: exist(type),
        value: type,
      }))}
    />
  );
};

ContractInsuranceTypeSelector.defaultProps = {
  onChange: () => null,
  defaultSelected: ContractInsuranceType.NONE,
};

export default ContractInsuranceTypeSelector;
